import {AnalyticsQueue} from '@invitae/analytics-queue'
import {AnalyticsUserPropertiesArguments} from '@invitae/analytics-queue/dist/types'

export interface AnalyticsEvent {
  type: string
  properties: Record<string, string>
}

export class AnalyticsQueueService {
  private analyticsQueue: AnalyticsQueue

  constructor(debug = false) {
    this.analyticsQueue = new AnalyticsQueue(debug)
  }

  // Checked at call time so the module-level singleton doesn't cache a stale value
  // if it initializes before Cypress injects window.Cypress.
  // TODO: replace with constructor injection — accept an IAnalyticsQueue param and
  // let tests pass a stub queue via cy.window()._testAnalyticsQueue, removing the
  // Cypress-awareness from production code entirely.
  private get isCypress(): boolean {
    return !!(window as any).Cypress
  }

  public setUserProperties(properties: AnalyticsUserPropertiesArguments): void {
    if (this.isCypress) {
      const stub = (window as any)._analyticsQueueSetUserProperties
      stub?.(properties)

      return
    }

    this.analyticsQueue.setUserProperties(properties)
  }

  public logEvent(event: AnalyticsEvent) {
    const eventFormatted = {
      eventName: event.type,
      eventProperties: {
        ...event.properties,
        'Current Page URL': window.location.href,
      },
    }

    if (this.isCypress) {
      const stub = (window as any)._analyticsQueueLogEvent
      stub?.(eventFormatted)

      return
    }

    this.analyticsQueue.logEvent(eventFormatted)
  }

  public pageViewLogEvent(pageName: string, properties: Record<string, string>) {
    if (this.isCypress) {
      const stub = (window as any)._analyticsQueueLogEvent
      stub?.(pageName, properties)

      return
    }

    this.analyticsQueue.pageViewLogEvent(pageName, properties)
  }
}

export const AnalyticsService = new AnalyticsQueueService()
